export const PULSE_SCHEMA_VERSION =
  'http://schema.adevinta.com/events/tracker-event.json/262.json';
